import React from "react";
import classes from "../styles/style.module.css";
import FaqImg from "../../../assets/images/Roshana/faq.png";
import Collapsible from "react-collapsible";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

const qa = [
  {
    q: "حلقه کتاب‌خوانی در چه بستری برگزار می‌شود؟",
    a: "‌طرح کتاب‌خوانی در فضای مجازی و در پیام‌رسان ایتا یا تلگرام برگزار می‌شود. پس از ثبت‌نام لینک کانال و گروه طرح در اختیار شما قرار خواهد گرفت که می‌توانید در آن‌ها عضو شوید.",
  },
  {
    q: "آیا جلسات و دوره‌های حضوری نیز در حلقه کتاب‌خوانی برگزار می‌شود؟",
    a: "اساس ‌طرح کتاب‌خوانی در بستر فضای مجازی است. اما برخی از جلسات جمع‌بندی کتاب، به صورت حضوری نیز برگزار می‌شود.",
  },
  {
    q: "آیا در ‌حلقه کتاب‌خوانی، برنامه مطالعه روزانه خواهیم داشت؟",
    a: "بله. در آغاز مطالعه هر کتاب، برنامه مطالعه روزانه کتاب با عنوان «مقرری روزانه» در اختیار شما قرار می‌گیرد. و هر روز می‌توانید طبق آن برنامه مطالعه کنید.",
  },
  {
    q: "برای شرکت در ‌حلقه کتاب‌خوانی، چه میزان باید وقت بگذاریم؟",
    a: "برنامه مطالعه هر روز، حدود 15 تا 20 صفحه است. یعنی با زمان حدودی 30 دقیقه یا کمتر در روز می‌توانید در ‌طرح کتاب‌خوانی شرکت کنید.",
  },
  {
    q: "آیا برای شرکت در ویژه‌برنامه‌های ماراتن کتاب کودک، و وبینار جمع‌بندی کتاب باید هزینه جداگانه پرداخت کنیم؟",
    a: "خیر. تمام برنامه‌های طرح کتاب‌خوانی به صورت رایگان برگزار می‌شود؛ و برای شرکت در برنامه‌های مختلف و دریافت کتاب، هیچ هزینه‌ای دریافت نمی‌شود.",
  },
];

const Faq = () => {
  return (
    <div className="customContainer">
      <div className={classes.hintContainer}>
        <div className={classes.hintHeader}>
          <img src={FaqImg} alt="courseInfromationImg" />
        </div>
        <p className={classes.hintSecondTitle}>پرسش های متداول</p>
        <div className="w-100">
          {qa.map((item, index) => (
            <Collapsible
              key={index}
              className={classes.collapseContainer}
              openedClassName={classes.collapseContainer}
              trigger={
                <div className={classes.triggerContainer}>
                  <div className="text-right">{item.q}</div>
                  <div className={classes.arrowContainer}>
                    <MdKeyboardArrowDown fontSize={30} />
                  </div>
                </div>
              }
              triggerWhenOpen={
                <div className={classes.triggerContainer}>
                  <div className="text-right">{item.q}</div>
                  <div className={classes.arrowContainer}>
                    <MdKeyboardArrowUp fontSize={30} />
                  </div>
                </div>
              }
              easing="cubic-bezier(0.25, 0.1, 0.25, 1)"
            >
              <div className={classes.collapseContent}>
                <p>{item.a}</p>
              </div>
            </Collapsible>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faq;
